export default [
  {
    formFields: [
      {
        title: 'Thumbnail Image',
        type: 'image',
        property: 'thumbnailFileId',
        value: null,
        caption: '.png or.jpg, 500px X 200px',
        options: {
          aspectRatio: 1/1,
          width: 100,
          placeholderColor: '#e5e5e5',
          placeholderText: '',
          cropperSettings: {
            title: 'Thumbnail Image',
            aspectRatio: 1/1,
          }
        }
      },
      {
        title: 'PDF name',
        type: 'text',
        property: 'title',
        value: '',
        counter: 150,
        rules: [(v) => !!v || 'PDF name is required', (v) => v.length <= 150 || 'PDF name must be 150 characters or less'],
        required: true
      },
      {
        title: 'PDF file',
        type: 'file',
        property: 'fileId',
        value: null,
        rules: [
          (v) => !!v || 'File is required',
          (value) => {
            if (!value) { return true; }
            if (value.type && ['application/pdf'].indexOf(value.type) === -1) {
              return 'This file type is not valid';
            }
            return true;
          }
        ],
        options: {
          acceptedMimes: ['application/pdf']
        }
      }
    ]
  }
];
